import { connect } from 'react-redux';
import { withI18n } from 'react-i18next';
import { withRouter } from 'react-router';

import CartView from './CartView';

import { IInitialState } from 'src/store/initialState';
import {
  cartItemsSel,
  cartItemCountSel,
  cartDeliverMethodSel,
  cartDeliveryLocationSel,
  cartDeliverLocationCodeSel,
  cartSuppliedFromCodeSel,
  cartSubtotalSel,
  cartIsPendingSel,
  cartUpdatingSel,
  cartErrorSel,
  cartSuccessSel,
  cartPendingListsSel,
  cartFileStatus
} from 'src/store/modules/cart/selectors';
import { cartActions } from 'src/store/modules/cart';
import { warrantyActions } from 'src/store/modules/warranty';
import { userActions, userDataSel } from 'src/store/modules/user';
import AddressModel from 'src/model/address.model';
import OneTimeAddressModel from 'src/model/oneTimeAddress.model';
import { warrantyProvidersSel } from 'src/store/modules/warranty';
import { ICartSuccess } from 'src/store/modules/cart/reducers';

import { analyticsActions } from 'src/analytics/store';

const mapStateToProps = (state: IInitialState) => ({
  items: cartItemsSel(state),
  itemCount: cartItemCountSel(state),
  deliverMethod: cartDeliverMethodSel(state),
  deliveryLocation: cartDeliveryLocationSel(state),
  deliveryLocationCode: cartDeliverLocationCodeSel(state),
  suppliedFromCode: cartSuppliedFromCodeSel(state),
  subtotal: cartSubtotalSel(state),
  isPending: cartIsPendingSel(state),
  updating: cartUpdatingSel(state),
  userData: userDataSel(state),
  error: cartErrorSel(state),
  warrantyProviders: warrantyProvidersSel(state),
  cartSuccess: cartSuccessSel(state),
  isPendingList: cartPendingListsSel(state),
  isFileStatus: cartFileStatus(state)
});

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  onLoad: () => {
    dispatch(cartActions.getInfo());
    dispatch(userActions.getUserDetails());
  },
  onRemoveItem: (itemID: number) => {
    dispatch(cartActions.deleteItem(itemID));
    dispatch(analyticsActions.productRemoveFromCart(itemID));
  },
  onClearfavList: () => dispatch(cartActions.clearCart()),
  onClearCart: () => dispatch(cartActions.clearCart()),
  onAddItemSimple: (partNumber: string, quantity: number) =>
    dispatch(cartActions.addSimpleItem(partNumber, quantity)),
  onAddItem: (
    claims: string,
    delivery: string,
    deliveryLocation: string,
    oneTimeAddress: OneTimeAddressModel,
    partNumber: string,
    quantity: number,
    rushOrder: boolean,
    shipmentMarking: string,
    shipsfrom: string,
    ticketNumber: string,
    warrantyProvider: string
  ) => {
    dispatch(
      cartActions.addItem(
        claims,
        delivery,
        deliveryLocation,
        oneTimeAddress,
        partNumber,
        quantity,
        rushOrder,
        shipmentMarking,
        shipsfrom,
        ticketNumber,
        warrantyProvider
      )
    );
  },
  onUpdateItem: (
    claims: string,
    id: number,
    quantity: number,
    shipmentMarking: string,
    shipsfrom: string,
    warrantyProvider: string,
    rushOrder: boolean,
    ticketNumber: string,
    isRefresh: boolean
  ) => {
    dispatch(
      cartActions.updateItem(
        claims,
        id,
        quantity,
        shipmentMarking,
        shipsfrom,
        warrantyProvider,
        rushOrder,
        ticketNumber,
        isRefresh
      )
    );
  },
  onUploadItemsFromFile: (file: FormData) => {
    dispatch(cartActions.uploadItemsFromFile(file));
  },
  onSwitchDeliverMethod: (
    delivery: string,
    deliveryLocation: string,
    oneTimeAddress: OneTimeAddressModel | null
  ) => {
    dispatch(
      cartActions.switchDeliverMethod(
        delivery,
        deliveryLocation,
        oneTimeAddress
      )
    );
  },
  onSwitchShipFrom: (deliveryLocation: string) => {
    dispatch(cartActions.switchShipFrom(deliveryLocation));
  },
  getWarrantyProviders: () => dispatch(warrantyActions.getWarranty()),
  closeAlertSuccess: (success: ICartSuccess) => {
    dispatch(cartActions.setSuccess(success));
  },
  updateCartItemQuantityAnalytics: (data: any) =>
    dispatch(analyticsActions.updateCartItemQuantity(data))
});

export const pureComponent = CartView;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(withRouter(CartView as any)));

interface IDispatchFromProps {
  onLoad(): void;
  onRemoveItem(itemID: number): any;
  onClearfavList(): void;
  onClearCart(): void;
  onAddItemSimple(partNumber: string, quantity: number): any;
  onAddItem(
    claims: string,
    delivery: string,
    deliveryLocation: string,
    oneTimeAddress: OneTimeAddressModel,
    partNumber: string,
    quantity: number,
    rushOrder: boolean,
    shipmentMarking: string,
    shipsfrom: string,
    ticketNumber: string,
    warrantyProvider: string
  ): any;
  onUpdateItem: (
    claims: string,
    id: number,
    quantity: number,
    shipmentMarking: string,
    shipsfrom: string,
    warrantyProvider: string,
    rushOrder: boolean,
    ticketNumber: string,
    isRefresh: boolean
  ) => void;
  onChangeShipTo?: (address: AddressModel) => void;
  onUploadItemsFromFile: (file: FormData) => void;
  onSwitchDeliverMethod: (
    delivery: string,
    deliveryLocation: string,
    oneTimeAddress?: OneTimeAddressModel | null
  ) => void;
  onSwitchShipFrom: (deliveryLocation: string) => void;
  getWarrantyProviders: () => void;
  closeAlertSuccess: (success: ICartSuccess) => void;
  updateCartItemQuantityAnalytics: (data: any) => void;
}
